function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "coffee_cup"
}, /*#__PURE__*/React.createElement("path", {
  d: "m18 7c-.342 0-.675.059-1 .144v-1.144c0-.552-.447-1-1-1h-13c-.553 0-1 .448-1 1v7c0 3.309 2.691 6 6 6h3c2.689 0 4.97-1.778 5.73-4.22.407.137.833.22 1.27.22 2.206 0 4-1.794 4-4s-1.794-4-4-4zm-7 10h-3c-2.206 0-4-1.794-4-4v-6h11v6c0 2.206-1.794 4-4 4zm7-4c-.355 0-.698-.098-1-.274v-3.452c.302-.176.645-.274 1-.274 1.103 0 2 .897 2 2s-.897 2-2 2z"
}));

var Svg032Cup = function Svg032Cup(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg032Cup, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/032-cup.e7d2148b.svg";
export { ForwardRef as ReactComponent };